// Melding op het bord als het gezinsbord verwijderd gaat worden (0036). Franse tegenhanger.
export const kioskPrivacyFr = {
    closingTitle: 'Ce tableau s’arrête le {date}',
    closingBody: 'Ce n’est pas prévu ? Demande à un parent : on peut encore l’arrêter dans l’app.',
};
//# sourceMappingURL=kioskPrivacy.fr.js.map